import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  width: 100%;
`;

export const SliderItem = styled.div<{ height?: number | string; padding?: number | string }>`
  background: transparent;
  max-width: 100%;
  height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
  padding: ${({ padding }) => (typeof padding === 'string' ? padding : `${padding}px`)};
  &:focus-visible {
    border: none;
    outline: none;
  }
`;
SliderItem.defaultProps = {
  height: 200,
  padding: 0,
};

export const SliderThumbnail = styled.div<{ margin?: string | number; width?: string }>`
  margin: ${({ margin }) => margin};
  width: ${({ width }) => width};
`;

SliderThumbnail.defaultProps = {
  margin: `0`,
  width: 'auto',
};

export const SliderThumbnailItem = styled.div<{ thumbnailBorderWidth?: number }>`
  padding: ${({ thumbnailBorderWidth }) => `${thumbnailBorderWidth}px`};
  background: transparent;
  &:focus-visible {
    border: none;
    outline: none;
  }
`;

SliderThumbnailItem.defaultProps = {
  thumbnailBorderWidth: 1,
};

export const SliderThumbnailImage = styled.img<{
  active?: boolean;
  marginRight?: number | 0;
  thumbnailBorderWidth?: number;
  thumbnailSize?: number;
}>`
  width: ${({ thumbnailSize }) => `${thumbnailSize}px`};
  height: ${({ thumbnailSize }) => `${thumbnailSize}px`};
  margin-right: ${({ marginRight }) => `${marginRight}px` || 0};
  outline: ${({ active, thumbnailBorderWidth }) =>
    active ? `${thumbnailBorderWidth}px solid white` : 'none'};
  background: #ffffff1a;
  border-radius: 8px;
  object-fit: fit;
  cursor: pointer;
  opacity: ${({ active }) => (!active ? `0.5` : '1')};
`;

SliderThumbnailImage.defaultProps = {
  active: false,
  marginRight: 10,
  thumbnailBorderWidth: 1,
  thumbnailSize: 52,
};

export const SliderThumbnailIcon = styled.div<{
  active?: boolean;
  marginRight?: number | 0;
  thumbnailBorderWidth?: number;
  thumbnailBorderColor?: string;
  background?: string;
  thumbnailSize?: number;
  isNotesGallery?: boolean;
  inFullScreen?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ thumbnailSize }) => `${thumbnailSize}px`};
  height: ${({ thumbnailSize }) => `${thumbnailSize}px`};
  margin-right: ${({ marginRight }) => `${marginRight}px` || 0};
  outline: ${({ active, isNotesGallery, thumbnailBorderWidth, thumbnailBorderColor }) =>
    active || isNotesGallery ? `${thumbnailBorderWidth}px solid ${thumbnailBorderColor}` : 'none'};
  background: ${({ isNotesGallery, inFullScreen, background }) =>
    isNotesGallery && inFullScreen ? '#0000001A' : background || '#ffffff1a'};
  border-radius: 8px;
  cursor: pointer;
  opacity: ${({ active }) => (!active ? `0.5` : '1')};
`;

SliderThumbnailIcon.defaultProps = {
  active: false,
  marginRight: 10,
  thumbnailBorderWidth: 1,
  background: '#ffffff1a',
  thumbnailSize: 52,
  thumbnailBorderColor: 'white',
};

export const SliderImage = styled.img<{ inFullScreen: boolean; isNotesGallery?: boolean }>`
  position: relative;
  margin: auto;
  max-width: 100%;
  height: 100%;
  object-fit: ${({ inFullScreen }) => (inFullScreen ? `contain` : 'cover')};
  border-radius: ${({ isNotesGallery }) => (isNotesGallery ? `0` : '8px')};
  cursor: pointer;
`;

SliderImage.defaultProps = {
  inFullScreen: false,
};

export const SliderVideo = styled.video`
  position: relative;
  margin: auto;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
`;

export const GalleryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 48px;
  height: 48px;
  background-color: #ffffff1a;
  border-radius: 8px;
  z-index: 10;
  backdrop-filter: blur(2px);
  transition-duration: 0.5s;
  &:hover {
    background-color: #ffffff33;
  }
  &:focus {
    background-color: #ffffff33;
  }
  &:before {
    content: none;
  }
`;
export const AlternativeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 36px;
  height: 36px;
  background-color: black;
  border-radius: 50%;
  z-index: 10;
  transition-duration: 0.5s;
  &:before {
    content: none;
  }
`;

export const SliderDots = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SliderDotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  background: transparent;
  cursor: pointer;
`;

export const SliderDot = styled.div<{ active: boolean; dotsColor: string }>`
  background-color: ${({ dotsColor }) => dotsColor};
  opacity: ${({ active }) => (active ? 1 : 0.4)};
  width: 5px;
  height: 5px;
  border-radius: 999rem;
`;
